var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopStep910(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 16,
    viewBox: "0 0 31 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.288987 7.29289C-0.101537 7.68342 -0.101537 8.31658 0.288987 8.70711L6.65295 15.0711C7.04347 15.4616 7.67664 15.4616 8.06716 15.0711C8.45769 14.6805 8.45769 14.0474 8.06716 13.6569L2.41031 8L8.06716 2.34314C8.45768 1.95262 8.45768 1.31946 8.06716 0.928931C7.67664 0.538407 7.04347 0.538407 6.65295 0.928931L0.288987 7.29289ZM30.9961 6.99999L0.996094 7L0.996094 9L30.9961 8.99999L30.9961 6.99999Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopStep910);
export default __webpack_public_path__ + "static/media/laptop_step_9_10.d0d60049c589cf6c21da7c3a664bf547.svg";
export { ForwardRef as ReactComponent };